/**
 * Per-tab game session ({roomCode, playerId, rejoinToken}) kept in
 * sessionStorage so a page refresh can reclaim the player's seat.
 * Storage can be unavailable (private mode, blocked site data) - every access
 * is best-effort.
 */

const KEY = 'anagrabble:session';

export interface GameSession {
  roomCode: string;
  playerId: string;
  rejoinToken: string;
}

export function loadSession(): GameSession | null {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw) as Partial<GameSession>;
    if (typeof s.roomCode === 'string' && typeof s.playerId === 'string' && typeof s.rejoinToken === 'string') {
      return { roomCode: s.roomCode, playerId: s.playerId, rejoinToken: s.rejoinToken };
    }
  } catch {
    // ignore
  }
  return null;
}

export function saveSession(session: GameSession): void {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(session));
  } catch {
    // ignore
  }
}

export function clearSession(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
